"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../../utils/validations");
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
const StreamPartID_1 = require("../../../utils/StreamPartID");
class StatusAckMessage extends TrackerMessage_1.default {
    constructor({ version = TrackerMessage_1.default.LATEST_VERSION, requestId, streamId, streamPartition }) {
        super(version, TrackerMessage_1.default.TYPES.StatusAckMessage, requestId);
        (0, validations_1.validateIsNotEmptyString)('streamId', streamId);
        (0, validations_1.validateIsNotNegativeInteger)('streamPartition', streamPartition);
        this.streamId = streamId;
        this.streamPartition = streamPartition;
    }
    getStreamPartID() {
        return (0, StreamPartID_1.toStreamPartID)(this.streamId, this.streamPartition);
    }
}
exports.default = StatusAckMessage;
//# sourceMappingURL=StatusAckMessage.js.map